module.exports = __webpack_public_path__ + "static/media/LK__EV charger1.a86aa74b.svg";